import React, { useEffect } from 'react';
import closeIcon from '@assets/images/close/icon-CloseButton@3x.png';
import cn from 'classnames';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import Modal from './modal';
import ModalPopup from '@components/common/Modal';
import style from './orderItemDetail.module.scss';
import { getImageUrl } from '@utility/utills';
import warningImage from '@assets/images/warning-black.png';
import Tabs from './TabComponent';
import { flowType } from '@utility/userInfo';
import MoreInfo from './moreInfo';

const Pane = (props) => {
  return (
    <div>
      {props.children}
    </div>
  );
};

const OrderItemDetail = (props) => {
  const ItemDetails = props.itemInfo.menuItem;
  const itemDetailsInfo = props.itemInfo;
  const { info, setInfo } = props;
  const isKiosk = flowType() === 'kiosk';
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {isKiosk && (
        <>
          <div className="h-75 w-100 row m-0">
            <div className={cn('position-relative col-6 w-100 p-0 h-100', props.circularImages ? 'd-flex justify-content-center mt-3' : '')}>
              {!props.suppressImages && (ItemDetails?.imageUrl) ? (
                <img src={getImageUrl(ItemDetails, 'itemDetail', window.screen.width, null, props.circularImages)} alt="" className={cn(props.circularImages && window.innerWidth < 1023 ? '' : style.itemImage, getImageUrl(ItemDetails, 'itemDetail', window.screen.width) ? '' : 'd-none')} />
              ) : (
                <img src={getImageUrl(ItemDetails.imageUrl, null, null, null, props.circularImages)} alt="" className={cn(props.circularImages && window.innerWidth < 1023 ? '' : style.itemImage, getImageUrl(ItemDetails.imageUrl) ? '' : 'd-none')} />
              )}
            </div>
            <div className={cn('col-6 w-100 mx-0 h-100 text-justify overflowY od-text-primary text-primary p-0')}>
              {itemDetailsInfo.menuItem.description && (
                <div className={cn('col-12 px-2 fs-16')}>
                  {itemDetailsInfo.menuItem.description}
                </div>
              )}
              {itemDetailsInfo.menuItem.tags && itemDetailsInfo.menuItem.tags.length > 0 && (
                <div className={cn('flex-row pl-15', warningImage ? '' : 'd-flex')}>
                  {itemDetailsInfo.menuItem.tags.map((tag) => {
                    return (
                      <small className={cn('badge', ['kiosk'].includes(flowType()) && 'fs-10', style.tagName)}>
                        {tag.display && (
                          <>
                            {tag.imageUrl ? (
                              <div className>
                                <img src={tag.imageUrl} alt={tag.shortName} width="25" height="20" className={cn(style.tagImg)} />
                              </div>
                            ) : (
                              tag.shortName && (
                                <div className={cn(style.tagTextBox)} style={{ color: tag.color }}>
                                  {tag.shortName}
                                </div>
                              )
                            )}
                          </>
                        )}
                      </small>
                    );
                  })}
                </div>
              )}
              {(itemDetailsInfo.menuItem.disclaimer) && (
                <div className={cn(style.disclaimerMessage, 'row fs-14 m-2 od-disclaimer-background')}>
                  <div className="col-1 px-0"><img src={warningImage} alt="" className="w-100" /></div>
                  <div className="col-11 px-1">{itemDetailsInfo.menuItem.disclaimer}</div>
                </div>
              )}
            </div>
          </div>
          <div id="itemName" className={cn('w-100 row fs-22 mx-0 p-0')}>
            <div className={cn('col-9 px-1 fw-500 od-header-font-family text-primary od-text-primary')}>{itemDetailsInfo.menuItem.name ? itemDetailsInfo.menuItem.name : ''}</div>
            <div className="col-3 px-1 text-primary od-text-primary text-right">{itemDetailsInfo.price > 0 && `${LABEL().CURRENCY_SYMBOL}${Number(itemDetailsInfo.price).toFixed(2)}`}</div>
          </div>
        </>
      )}

      {info && (
        <Modal
          isOpen={info}
          toggleModal={() => { setInfo(!info); }}
          customClass={isKiosk ? style.maxWidth : ''}
        >
          {!isKiosk ? (
            <>
              <div className={cn(style.info)} onClick={() => { setInfo(!info); }} role="presentation">
                <img src={closeIcon} alt="" className="d-flex" width="20px" height="20px" />
              </div>
              <Tabs>
                <Pane label={LABEL().ITEM_FACTS}>
                  {(ItemDetails?.imageUrl) ? (
                    <img src={getImageUrl(ItemDetails, 'itemDetail', window.screen.width)} alt="" className={cn(style.itemImage, getImageUrl(ItemDetails, 'itemDetail', window.screen.width) ? '' : 'd-none')} />
                  ) : (
                    <img src={getImageUrl(ItemDetails.imageUrl)} alt="" className={cn(style.itemImage, getImageUrl(ItemDetails.imageUrl) ? '' : 'd-none')} />
                  )}
                  <div id="itemName" className={cn('m-2')}>
                    <div className={cn(style.itemNameComp, 'od-header-font-family od-text-primary')}>{ItemDetails.name ? ItemDetails.name : ''}</div>
                  </div>
                  {ItemDetails.description && (
                    <div className="m-2">
                      {ItemDetails.description}
                    </div>
                  )}
                  {(ItemDetails.disclaimer) && (
                    <div className={cn(style.disclaimerMessage, 'row fs-10 m-2 od-disclaimer-background')}>
                      <img src={warningImage} alt="" height="20px" width="20px" />
                      <div className="col-11">{ItemDetails.disclaimer}</div>
                    </div>
                  )}
                  {ItemDetails.tags && ItemDetails.tags.length > 0 && (
                    <div className={cn('flex-row m-2 d-flex', style.tagContainer)}>
                      {ItemDetails.tags.map((tag) => {
                        return (
                          <small className={cn('badge', ['kiosk'].includes(flowType()) && 'fs-10', style.tagName)}>
                            {tag.display && (
                              <>
                                {tag.imageUrl ? (
                                  <div className>
                                    <img src={tag.imageUrl} alt={tag.shortName} width="25" height="20" className={cn(style.tagImg)} />
                                  </div>
                                ) : (
                                  tag.shortName && (
                                    <div className={cn(style.tagTextBox)} style={{ color: tag.color }}>
                                      {tag.shortName}
                                    </div>
                                  )
                                )}
                              </>
                            )}
                          </small>
                        );
                      })}
                    </div>
                  )}
                </Pane>
                {(ItemDetails.nutritionFact) && (
                  <Pane label={LABEL().NUTRITION_FACT}>
                    <div className={`d-flex justify-content-start ${style.borderBottom}`}>
                      <div className={cn(style.fs42, 'fw-600 w-100 pb-2')}>{LABEL().NUTRITION_FACT}</div>
                    </div>
                    {ItemDetails?.nutritionFact ? (
                      <>
                        <div className={cn(style.lineHeight10, 'd-flex justify-content-between mx-2 flex-row')}>
                          {ItemDetails.nutritionFact.amountPerServing} servings per container
                        </div>
                        <div className="fs-12">
                          <div className="d-flex justify-content-between mx-2 fw-600 flex-row">
                            <div>
                              Serving Size
                            </div>
                            <div>
                              {ItemDetails.nutritionFact.servingSize}
                            </div>
                          </div>
                        </div>
                        <div className={cn(style.thickBorder, 'mx-2')} />
                        <div>
                          <div className={cn('d-flex justify-content-between mx-2 fw-700 flex-row')}>
                            <div className={cn(style.lineHeight30)}>
                              Amount per serving
                              <div className={cn(style.fs32)}>
                                Calories
                              </div>
                            </div>
                            <div className={cn(style.fs42, 'd-flex justify-content-center align-items-center')}>
                              {ItemDetails.nutritionFact.calories}
                            </div>
                          </div>
                        </div>
                        <div className={cn(style.thick3pxBorder, 'mx-2')} />
                        <div>
                          <div className={cn(style.borderBottom, 'd-flex justify-content-end mx-2 fw-600 flex-row')}>
                            <div className="">
                              {ItemDetails.nutritionFact.amountPerService}% Daily Value*
                            </div>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 fw-600 flex-row')}>
                          <div className="col p-0">
                            Total Fat{" "}
                            <span className="fw-100 pl-1">
                              {ItemDetails.nutritionFact.totalFat}g
                            </span>
                          </div>
                          <div className="col pr-0 d-flex justify-content-end">
                            <span>{ItemDetails.nutritionFact.totalFatPercentDaily}%</span>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <div className="col pr-0">
                            Saturated Fat{" "}
                            <span className="fw-100 pl-1">
                              {ItemDetails.nutritionFact.saturatedFat}g
                            </span>
                          </div>
                          <div className="col p-0 d-flex justify-content-end fw-600">
                            <span>{ItemDetails.nutritionFact.saturatedFatPercentDaily}%</span>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <div className="col pr-0">
                            Trans Fat{" "}
                            <span className="pl-1">
                              {ItemDetails.nutritionFact.transFat}g
                            </span>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 fw-600 flex-row')}>
                          <div className="col p-0">
                            Cholesterol{" "}
                            <span className="fw-100 pl-1">
                              {ItemDetails.nutritionFact.cholesterol}mg
                            </span>
                          </div>
                          <div className="col pr-0 d-flex justify-content-end">
                            <span>{ItemDetails.nutritionFact.cholesterolPercentDaily}%</span>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 fw-600 flex-row')}>
                          <div className="col p-0">
                            Soduim{" "}
                            <span className="fw-100 pl-1">
                              {ItemDetails.nutritionFact.sodium}mg
                            </span>
                          </div>
                          <div className="col pr-0 d-flex justify-content-end">

                            <span>{ItemDetails.nutritionFact.sodiumPercentDaily}%</span>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 fw-600 flex-row')}>
                          <div className="">
                            Total Carbohydrate{" "}
                            <span className="fw-100 pl-1">
                              {ItemDetails.nutritionFact.totalCarbohydrate}g
                            </span>
                          </div>
                          <div>{ItemDetails.nutritionFact.totalCarbohydratePercentDaily}%</div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <div className="col pr-0">
                            Dietary Fiber{" "}
                            <span className="pl-1">
                              {ItemDetails.nutritionFact.dietaryFiber}g
                            </span>
                          </div>
                          <div className="col p-0 d-flex justify-content-end fw-600">
                            <span>{ItemDetails.nutritionFact.dietaryFiberPercentDaily}%</span>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <div className="col pr-0">
                            Total Sugars{" "}
                            <span className="pl-1">
                              {ItemDetails.nutritionFact.totalSugar}g
                            </span>
                          </div>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <div className="col pl-30">Includes {ItemDetails.nutritionFact.addedSugar}g Added Sugars</div>
                          <span className="">
                            {ItemDetails.nutritionFact.totalSugarPercentDaily}%
                          </span>
                        </div>
                        <div className={cn('d-flex justify-content-between mx-2 fw-600 flex-row')}>
                          <div className="col p-0">
                            Protein{" "}
                            <span className="fw-100 pl-1">
                              {ItemDetails.nutritionFact.protein}g
                            </span>
                          </div>
                        </div>
                        <div className={cn(style.thickBorder, 'mx-2')} />
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <span>Vitamin D {ItemDetails.nutritionFact.vitaminD}mcg</span>
                          <span>{ItemDetails.nutritionFact.vitaminDPercentDaily}%</span>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <span>Calcium {ItemDetails.nutritionFact.calcium}mg</span>
                          <span>{ItemDetails.nutritionFact.calciumPercentDaily}%</span>
                        </div>
                        <div className={cn(style.borderBottom, 'd-flex justify-content-between mx-2 flex-row')}>
                          <span>Iron {ItemDetails.nutritionFact.iron}mg</span>
                          <span>{ItemDetails.nutritionFact.ironPercentDaily}%</span>
                        </div>
                        <div className={cn('d-flex justify-content-between mx-2 flex-row')}>
                          <span>Potassium {ItemDetails.nutritionFact.potassium}mg</span>
                          <span>{ItemDetails.nutritionFact.potassiumPercentDaily}%</span>
                        </div>
                        <div className={cn(style.thick3pxBorder, 'mx-2')} />
                        <div className="d-flex justify-content-between mx-2 fs-10">
                          * The % Daily Value (DV) tells you how much a nutrient in a serving of food contributes to a daily diet. 2,000 calories
                          a day is used for general nutrition advice.
                        </div>
                      </>
                    ) : (
                      <div className="d-flex justify-content-center">No nutrition fact details available</div>
                    )}
                  </Pane>
                )}
              </Tabs>
            </>
          ) : (
            <div className="h-100">
              <div className="h-90">
                <MoreInfo
                  setInfo={setInfo}
                  info={info}
                  ItemDetails={ItemDetails}
                  itemDetailsInfo={itemDetailsInfo}
                  {...props}
                />
              </div>
              <div className="col-12 p-2 row mx-0 align-items-end h-10">
                {isKiosk && (
                  <div className="col-6">
                    <button disabled={ItemDetails.outOfStock || ItemDetails.badge === 1 || ItemDetails.badge === 6} className={cn('btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-22')} type="button" onClick={() => { setInfo(!info); props.addToCart(itemDetailsInfo.menuItemId, itemDetailsInfo.menuTypeId, [], 'order'); }}>
                      {LABEL().ADD_TO_ORDER}
                    </button>
                  </div>
                )}
                <div className={isKiosk ? 'col-6' : 'col-12'}>
                  <button className={cn('btn btn100 btn-primary btn-ripple od-btn-primary shadow-none border-0 fw-700 w-100 fs-22')} type="button" onClick={() => setInfo(!info)}>
                    {LABEL().DONE}
                  </button>
                </div>
              </div>
            </div>
          )}
        </Modal>
      )}
      {props.isRemoveCartModelOpen && (
        <ModalPopup isOpen={props.isRemoveCartModelOpen} customClass2={isKiosk ? style.maxWidth : ''} isModalCenter>
          <div className={cn('mb-0 p-2')}>
            {!props.isKiosk && (
              <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
                <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
                  <div className="" role="presentation" onClick={() => { props.setRemoveCartModel(false); }}>
                    <i className="fa fa-times" aria-hidden="true" />
                  </div>
                </div>
              </div>
            )}
            <div className="mx-0 justify-content-center align-items-center text-center">
              <div className="fs-30 fw-600 text-center p-20">
                <div>
                  {CUSTOM_MESSAGES().DELETE_ITEM_CONFIRMATION}
                </div>
              </div>
              <div className="col-12 row mx-0 px-0 py-2 justify-content-center align-items-center">
                <div className="col-6 px-1">
                  <button className="w-100 btn btn100 btn-secondary od-btn-secondary fs-14" type="button" onClick={() => { props.setRemoveCartModel(false); }}>
                    <div className="fs-30">{LABEL().NO}</div>
                  </button>
                </div>
                <div className="col-6 px-1">
                  <button className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary fs-14" type="button" onClick={() => { props.setRemoveCartModel(false); props.onRemoveItemFromCart(); }}>
                    <div className="fs-30">{LABEL().YES}</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ModalPopup>
      )}
    </>
  );
};

export default OrderItemDetail;
